import React from 'react';
import createForm from "../Form";
import ComponentField from "../../../form/ComponentField";
import DateTimeInput from "../../../form/DateTimeInput";
import CheckBox from "../../../form/CheckBox";
import Select from "../../../form/Select";
import TextInput from '../../../form/TextInput';
import TextArea from '../../../form/TextArea';
import SelectorGrid from '../../../form/SelectorGrid/SelectorGrid';
import { CurrencyFormatter } from '../../../../utils/formatters';

class LoyaltyPointClearingReportForm extends React.Component {

    render() {
        const filterProps = {
            name: "filter",
            value: typeof this.props.values.filter === "string" ? JSON.parse(this.props.values.filter) : this.props.values.filter,
            saveChanges: this.props.setFieldValue
        };
        const disabled = !!this.props.values[this.props.componentConfig.idfield];
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="partner"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Partner"
                            disabled={disabled}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("report_date")}
                            name="report_date"
                            value={this.props.values.report_date}
                            label="Elszámolási időszak utolsó napja"
                            showTime={false}
                            // maxDate={}
                            saveChanges={this.props.setFieldValue}
                            disabled={disabled}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TextArea
                            {...this.props.getFieldProps("comment.text")}
                            name="comment.text"
                            value={(this.props.values.comment || {}).text}
                            label="Megjegyzés"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label className="control-label">Számlatételek</label>
                            <SelectorGrid
                                {...this.props.getFieldProps("items")}
                                ref={(e) => this.items = e}
                                className={"p-small-table"}
                                columns={{
                                    "id": {
                                        header: 'Kód',
                                        width: 3,
                                        sortable: true,
                                        filterable: true
                                    },
                                    "type_option.optionlabel": {
                                        header: 'Megnevezés',
                                        width: 3,
                                        sortable: true,
                                        filterable: true
                                    },
                                    "amount": {
                                        header: 'Összeg',
                                        width: 3,
                                        sortable: true,
                                        filterable: true,
                                        renderer: CurrencyFormatter
                                    },
                                }}
                                listfield="items"
                                data={this.props.values}
                                orderBy={{field: "id", direction: "ASC"}}
                                componentConfig={this.props.componentConfig}
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(LoyaltyPointClearingReportForm);
